import { forwardRef } from "react";
import PropTypes from "prop-types";

// Cards are centered as a group and wrap onto new rows. Sections whose cards have a fixed width can
// opt into a grid layout instead so a trailing card left-aligns under the first card of the row
// above rather than centering on its own row.
const DEFAULT_LAYOUT_CLASSES = "tw-flex tw-justify-center tw-flex-wrap";

const CardSection = forwardRef(
  ({ title, children = null, layoutClassName = DEFAULT_LAYOUT_CLASSES }, ref) => (
    <div ref={ref} className="tw-mt-[24px] tw-flex tw-flex-col tw-gap-[48px]">
      <div className="tw-text-gray-50 tw-text-[20px] tw-leading-[20px] tw-uppercase tw-text-center tw-font-[500] tw-tracking-[2px]">
        {title}
      </div>
      <div className={`${children ? "" : "tw-min-h-[500px]"} ${layoutClassName} tw-gap-[24px] tw-px-[24px]`}>
        {children}
      </div>
    </div>
  ),
);

CardSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  layoutClassName: PropTypes.string,
};

export default CardSection;
